import { ReactNode } from "react";

import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ModulePullRequestsTableRow } from "../../gql";
import { isModulePullRequestExpandable } from "../../helpers";
import ModulePullRequestsTablePullRequestGroupToggle from "./PullRequestGroupToggle";

type ModulePullRequestsTableGroupCellProps = TableSimpleCellProps<ModulePullRequestsTableRow> & {
  children: ReactNode;
};

const ModulePullRequestsTableGroupCell = ({
  item: pullRequest,
  isFirst,
  children,
  ...cellProps
}: ModulePullRequestsTableGroupCellProps) => {
  const isActive = isFirst && isModulePullRequestExpandable(pullRequest.runs);

  return (
    <TableSimpleCell {...cellProps}>
      {isActive && (
        <ModulePullRequestsTablePullRequestGroupToggle pullRequest={pullRequest}>
          {children}
        </ModulePullRequestsTablePullRequestGroupToggle>
      )}

      {!isActive && children}
    </TableSimpleCell>
  );
};

export default ModulePullRequestsTableGroupCell;
